import { render, staticRenderFns } from "./WordCloudView.vue?vue&type=template&id=74c1fa22&scoped=true&"
import script from "./WordCloudView.vue?vue&type=script&lang=js&"
export * from "./WordCloudView.vue?vue&type=script&lang=js&"
import style0 from "./WordCloudView.vue?vue&type=style&index=0&id=74c1fa22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c1fa22",
  null
  
)

export default component.exports